export default __webpack_public_path__ + "static/media/5.834f86b3.png";